<template>
    <div v-for="noti in systemNotificationsList" 
    :key="noti.CA131CODNOTIFICACION" 
    :class="'m-3 alert-dismissible fade show alert '+noti.CA131CLASEBOOSTRAPNOTIFICACION "
    role="alert">
      <i :class="noti.CA131ICONO"></i> {{ noti.CA131MENSAJE }}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
</template>


<script>

import useNotification from '@/modules/notification/composables/useNotification';

export default {

    setup() {

        const { systemNotificationsList, systemNotifications } = useNotification()
        // Cargar notificaciones del sistema
        systemNotifications()
        return {
            systemNotificationsList


        }
    }
}
</script>